import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { IconButton, ListItemText, Menu, MenuItem } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { TEACHERS_ASSIGNMENTS_DETAIL_URL } from 'config/urls';
import { softDeleteAssignment } from 'sdk';

import { StudentsProgressBar } from 'pages/Teachers/AssignmentsV2/components/AssignmentRow';
import Standard from 'pages/Teachers/AssignmentsV2/components/Standard';
import { colors } from 'theme/palette';
import { formatDate } from 'utils/moment';
import { notifyError, notifySuccess } from 'utils/notifications';
import { reverse } from 'utils/urls';

import Typography from 'components/Typography';

import styles from './styles.module.scss';

const Assignment = ({
  name,
  sectionName,
  submittedWorks,
  dueAt,
  studentsCount,
  standards,
  trackerId,
  assignmentId,
  isExportMode,
  isSelected,
  onToggleSelect,
  onDeleteSuccess,
  onClick
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    // Close the menu
    setAnchorEl(null);
  };

  const handleAssignmentEditClick = (event) => {
    event.stopPropagation();
    history.push({
      pathname: reverse(TEACHERS_ASSIGNMENTS_DETAIL_URL, {
        trackerId: trackerId
      })
    });
  };

  const handleAssignmentDeleteClick = async (event) => {
    event.stopPropagation();

    const { success, error } = await softDeleteAssignment(assignmentId);

    if (success) {
      notifySuccess('Assignment deleted successfully');
      onDeleteSuccess();
    } else {
      notifyError(error);
    }
  };

  const dateFormat = 'ddd MM/DD hh:mm a';

  return (
    <div className={styles.rowWrapper}>
      {isExportMode && (
        <div className={styles.checkboxWrapper}>
          <Checkbox checked={isSelected} onClick={onToggleSelect} />
        </div>
      )}
      <div className={styles.container} onClick={onClick}>
        <div>
          <Typography variant="H-TEXT-3" color={colors.blueDark}>
            {name}
          </Typography>
          <div className={styles.standardsList}>
            {standards.map((standard, index) => (
              <div key={index}>
                <Standard label={standard} />
              </div>
            ))}
          </div>
        </div>

        <Typography variant="S-TEXT-1" color={colors.blue2}>
          {sectionName}
        </Typography>

        <Typography variant="B-Text-3" color={colors.grey2}>
          {formatDate(dueAt, dateFormat)}
        </Typography>

        <div className={styles.progress}>
          <StudentsProgressBar
            lgScreen={true}
            colors={colors}
            numStudents={submittedWorks}
            totalStudents={studentsCount}
            barColor={colors.blueLight}
          />
        </div>

        <div>
          <IconButton
            aria-label="more"
            aria-controls="cabap-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreHorizIcon />
          </IconButton>

          <Menu
            id="cabap-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleAssignmentEditClick}>
              <EditIcon
                fontSize="small"
                style={{ color: colors.blue3, marginRight: '10px' }}
              />

              <ListItemText primary="Edit Assignment" />
            </MenuItem>
            <MenuItem onClick={handleAssignmentDeleteClick}>
              <DeleteIcon
                fontSize="small"
                style={{ color: colors.pink, marginRight: '10px' }}
              />

              <ListItemText primary="Delete Assignment" />
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Assignment;
